import { createAction } from 'redux-actions';

export const setResults = createAction('SET_RESULTS');
export const resetResults = createAction('RESET_RESULTS');

